import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PreviousRouteService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  private isFirstNavigation = true;

  constructor(private router: Router) {
    // Ascolta tutti gli eventi NavigationEnd, incluso il primo caricamento
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        if (this.isFirstNavigation) {
          // Primo evento: imposta sia previous che current alla rotta attuale
          this.currentUrl = event.urlAfterRedirects;
          this.previousUrl = event.urlAfterRedirects;
          this.isFirstNavigation = false;
        } else {
          // Aggiorna previous e current normalmente
          this.previousUrl = this.currentUrl;
          this.currentUrl = event.urlAfterRedirects;
        }
      });
  }

  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  public navigateToPrevious(): void {
    if (this.previousUrl) {
      this.router.navigateByUrl(this.previousUrl);
    }
  }
}
